/* global axios */
import ApiClient from './ApiClient';

// Traducción automática: borradores antes de enviar y mensajes entrantes
// (estos últimos se cachean en message.translations en el backend).
class AutoTranslateAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  translateDraft(conversationId, text, targetLanguage) {
    return axios.post(`${this.url}/${conversationId}/auto_translate`, {
      text,
      target_language: targetLanguage,
    });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(`${this.url}/${conversationId}/auto_translate`, {
      message_id: messageId,
      target_language: targetLanguage,
    });
  }
}

export default new AutoTranslateAPI();
